var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.46154H0V1.15385H6V3.46154ZM6 6.92308H0V9.23077H6V6.92308ZM22.308 15L17.712 10.5808C16.752 11.1808 15.624 11.5385 14.4 11.5385C11.088 11.5385 8.4 8.95385 8.4 5.76923C8.4 2.58462 11.088 0 14.4 0C17.712 0 20.4 2.58462 20.4 5.76923C20.4 6.94615 20.028 8.03077 19.404 8.94231L24 13.3731L22.308 15ZM18 5.76923C18 3.86538 16.38 2.30769 14.4 2.30769C12.42 2.30769 10.8 3.86538 10.8 5.76923C10.8 7.67308 12.42 9.23077 14.4 9.23077C16.38 9.23077 18 7.67308 18 5.76923ZM0 15H12V12.6923H0V15Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.c4459707088c9787e37564e4cfba87ae.svg";
export { ForwardRef as ReactComponent };